var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "appfade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.appIsLoaded,
                expression: "appIsLoaded",
              },
            ],
            key: "app-loaded-1",
            staticClass: "app-container",
          },
          [
            _c("app-header", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isHeaderFooterHidden,
                  expression: "!isHeaderFooterHidden",
                },
              ],
            }),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "pagefade" } },
              [_c("router-view", { key: _vm.$route.fullPath })],
              1
            ),
            _vm._v(" "),
            _c("app-footer", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isHeaderFooterHidden,
                  expression: "!isHeaderFooterHidden",
                },
              ],
            }),
            _vm._v(" "),
            _c("cookie-banner"),
            _vm._v(" "),
            _c("modals-container"),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "appfade" } }, [
        !_vm.appIsLoaded
          ? _c("div", { key: "app-not-loaded-2", staticClass: "is-black" }, [
              _c("h1", [_vm._v("data.json not found or invalid json")]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }